const getURLPath = (path: string): string | null => {
    if (!path) return null;
    
    // Remove query parameters and hash if present
    const cleanPath = path.split(/[?#]/)[0];
    
    // Remove trailing slash if exists and split by slashes
    const segments = cleanPath.replace(/\/$/, '').split('/');
    
    // Get the last non-empty segment
    const lastSegment = segments.pop() || '';

    return lastSegment || null;
}

const urlParamsParser = (parameter : string) : string | null => {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameter);
};

const parseHost = (url : string) : string => {
    return new URL(url).host;
};

const populateTokenNamespaces = () => {
    const namespacePrefixes = []
    //It's important that we push slug as the first element of the array as it's considered higher priority than domain if both are present.
    let slug = getURLPath(window.location.pathname.substring(1));
    let domain : string | null = null;
    const url = urlParamsParser("url");
    if (url) {  // Only proceed if url is not null
        domain = parseHost(url);
    }
    namespacePrefixes.push(slug, domain);

    return namespacePrefixes;
};

export {
    getURLPath,
    urlParamsParser,
    parseHost,
    populateTokenNamespaces
}